export default (text) => {
  const regex = /^[a-zA-Z.0-9]*$/;
  const isValid = text.match(regex);
  return !isValid;
};
